import PropTypes from 'prop-types';

const pinStyle = {
  cursor: 'pointer',
  pointerEvents: 'auto',
  filter: 'drop-shadow(0px 2px 5px rgba(0, 0, 0, .2))',
};

const MapPinSaved = ({ fill='#FED844', stroke='#052B52', width=69, height=82, ariaLabel='', onClick }) => {
  return (
    <svg
      //
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 85 100"
      style={{ ...pinStyle }}
      width={width}
      height={height}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      <defs>
        <path
          id="map-pin-normal-saved"
          d="M46.948 31.083l-5.285 5.43a.404.404 0 0 0-.034.132l2.051 7.329c.316 1.118-.325 1.69-.53 1.839a1.498 1.498 0 0 1-.868.28c-.294 0-.645-.088-1.03-.354l-6.753-4.667-6.75 4.666c-.955.66-1.697.224-1.9.075-.205-.149-.847-.721-.53-1.843l2.05-7.322a.396.396 0 0 0-.033-.135l-5.284-5.43c-.508-.52-.678-1.196-.457-1.804.221-.61.782-1.013 1.502-1.08l6.985-.66a.354.354 0 0 0 .097-.072l2.807-6.539c.296-.688.862-1.099 1.513-1.099.652 0 1.217.41 1.513 1.1l2.81 6.54a.362.362 0 0 0 .096.07l6.987.658c.72.07 1.282.474 1.5 1.084.22.608.05 1.281-.457 1.802M34.5 2C16.58 2 2 16.426 2 34.16c0 7.389 5.167 17.395 15.358 29.735 7.36 8.912 14.602 15.727 14.907 16.012a3.26 3.26 0 0 0 2.235.882c.805 0 1.609-.294 2.236-.882.304-.285 7.547-7.1 14.906-16.012C61.832 51.554 67 41.548 67 34.159 67 16.426 52.42 2 34.5 2"
        />
      </defs>
      <use fill={fill} fillRule="evenodd" stroke={stroke} strokeWidth="2.5" xlinkHref="#map-pin-normal-saved" />
    </svg>
  );
};

MapPinSaved.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  ariaLabel: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default MapPinSaved;
